var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifier",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.053,
    height: 21.032,
    viewBox: "0 0 21.053 21.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M20.662,20.642a1.315,1.315,0,0,1-1.871,0l-4.071-4.071a9.181,9.181,0,0,1-9.087,1.1,9.076,9.076,0,0,1-4.9-4.893,9.157,9.157,0,0,1,0-7.165,9.131,9.131,0,0,1,1.963-2.93A9.342,9.342,0,0,1,5.633.73a9.132,9.132,0,0,1,7.155,0,9.342,9.342,0,0,1,2.94,1.953,9.131,9.131,0,0,1,1.963,2.93,9,9,0,0,1,.73,3.577,8.97,8.97,0,0,1-1.83,5.51l4.071,4.071a1.315,1.315,0,0,1,0,1.871ZM9.211,2.632A6.557,6.557,0,0,0,2.632,9.2a6.547,6.547,0,0,0,6.579,6.569A6.557,6.557,0,0,0,15.79,9.2,6.547,6.547,0,0,0,9.211,2.632Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.15841ed01b8c3a4dd593c4d07b2771bf.svg";
export { ForwardRef as ReactComponent };